import {Injectable} from '@angular/core';
import {RequestService} from '../../services/request.service';
import {ConfigService} from '../../services/config.service';

@Injectable()
export class EvaluationService{
  private backUrl:string;

  constructor(
    private requestService: RequestService,
    private configService: ConfigService
  ){}

  getSphinxUrl(bucket: string, file: string): string {
    let result = this.configService.get('server').sphinx +
      this.configService.get('endpoints').sphinx.download.api +
      '/solar/jwt/'+bucket+'/' + file;
    return result;
  }

  storeUrl(content:string) {
    localStorage.setItem(this.backUrl, content);
  }

  retrieveUrl() {
    let storedUrl:string = localStorage.getItem(this.backUrl);
    if(!storedUrl)
      return null;
    return storedUrl;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/components/evaluation/evaluation.service.ts